let isUpdatingCart = false;

async function injectCartComparePrices(event) {
  if (isUpdatingCart) return;
  isUpdatingCart = true;

  const data = event.detail;
  if (!data?.items?.length) {
    isUpdatingCart = false;
    return;
  }

  const listHandle = data.items.map(i => i.handle);
  const opusCartV2 = JSON.parse(localStorage.getItem('opusCartV2')) || {};

  const products = await Promise.all(
    listHandle.map(handle =>
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .catch(err => {
          console.error(`Error fetching product ${handle}:`, err);
          return null;
        })
    )
  );

  products.forEach(product => {
    if (!product) return;

    const variants = product.variants || [];
    variants.forEach(item => {
      const variantId = item.id;
      const compareAtPrice = item.compare_at_price;

      window.OpusSetCompareAtPrice(variantId, {
        rate: window.Shopify.currency.rate,
        compareAtPrice,
        tags: product.tags || []
      });

      opusCartV2[variantId] = {
        compareAtPrice,
        rate: window.Shopify.currency.rate,
        tags: product.tags || []
      };
    });
  });

  localStorage.setItem('opusCartV2', JSON.stringify(opusCartV2));

  await window.opusRefreshCart();
  isUpdatingCart = false;
}

window.addEventListener('OpusCartChange', injectCartComparePrices);
window.addEventListener('OpusOpenCartState', injectCartComparePrices);